import { render, staticRenderFns } from "./ChatBlock.vue?vue&type=template&id=255fd91a&scoped=true"
import script from "./ChatBlock.vue?vue&type=script&lang=js"
export * from "./ChatBlock.vue?vue&type=script&lang=js"
import style0 from "./ChatBlock.vue?vue&type=style&index=0&id=255fd91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255fd91a",
  null
  
)

export default component.exports